import { useMutation, useQueryClient } from 'react-query';
import { ParticipantSharedService } from '../../services/wealthlane-customer-services';

const useGetMaskingDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setDobValue?: (value: string) => void | null,
  setSsnValue?: (value: string) => void | null
): any => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: string) => {
      if (payload === 'DOB') {
        return await handleRequest(
          ParticipantSharedService.getApiCustomerApiAppParticipantDateOfBirth()
        );
      } else if (payload === 'SSN') {
        return await handleRequest(
          ParticipantSharedService.getApiCustomerApiAppParticipantSocialSecurityNumber()
        );
      }
    },
    {
      onSuccess: (response: any, payload: string) => {
        payload === 'DOB'
          ? setDobValue && setDobValue(response)
          : setSsnValue && setSsnValue(response);
        queryClient.invalidateQueries('getParticipantPersonalDetails');
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetMaskingDetails;
